import styled from 'styled-components';
import { zeroPad } from 'react-countdown';
import { connect } from 'react-redux';
import Levels from './Levels';
import GameStatusIndicator from './GameStatusIndicator';
import SecondsCounter from './SecondsCounter';
import images from '../../../images';
import clockIcon from '../../../images/Clock.png';

const FeedbackContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 17.24vh 35px;
`;

const GoodJobFeedback = styled.div`
  background-size: contain;
  background-position: center;
  width: 33.33vh;
  height: 17.86vh;
  background-image: url(${images.good_job_feedback});
`;

const OopsFeedback = styled.div`
  background-size: contain;
  background-position: center;
  width: 28.57vh;
  height: 21.28vh;
  background-image: url(${images.oops_feedback});
`;

const Container = styled.div`
  overflow: hidden;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  min-height: calc(100vh - 40px - ${Number(window.statusBarHeight || 0)}px);
  margin-top: ${Number(window.statusBarHeight || 0)}px;
`;

const CardContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 0px 35px;
`;

const CountDownContainer = styled.div`
  position: fixed;
  display: flex;
  top: 0%;
  right: 6%;
  flex-direction: row;
`;

const TimerImage = styled.img`
  height: 6.67vw;
  width: 6.67vw;
  margin-top: 30%;
  margin-left: 5%;
`;

const CloseButton = styled.img`
  height: 5vw;
  width: 5vw;
  border-radius: 50%;
  position: fixed;
  top: 2.8%;
  left: 6%;
`;

const TopContainer = styled.div`
  position: fixed;
  display: flex;
  top: 3%;
  justify-content: space-between;
  flex-direction: row;
`;

const Feedback = styled.div`
  overflow-y: hidden;
  position: fixed;
  width: 85%;
  overflow-x: hidden;
  height: 62.5vh;
  padding: 5px;
  background-color: white;
  background-size: auto 85%;
  background-repeat: no-repeat;
  background-position: center center;
  max-width: 85%;
  max-height: 62.5vh;
  will-change: transform;
  border-radius: 10px;
`;

const feedbackState = {
  wrong: (
    <FeedbackContainer className="wrong animate__animated animate__headShake">
      <OopsFeedback />
    </FeedbackContainer>
  ),
  correct: (
    <FeedbackContainer className="correct animate__animated animate__fadeIn">
      <GoodJobFeedback />
    </FeedbackContainer>
  )
};

/**
 * This component shows the result of user's answer for each question
 * in two situation of Good Job or Oops
 *
 */
const Feedbacks = (
  {
    currentLevel,
    modalVisible,
    doneMaterials,
    passedMaterialsCount,
    feedbackStatus,
    recycleRightData,
    rrGameOnly
  }
) => {
  const CountDownRectangle = styled.div`
    position: fixed;
    top: ${Number(window.innerHeight / window.innerWidth) * -1.875 + 6.375}%;
    right: 4.5%;
    height: ${(Number(window.innerHeight / window.innerWidth) > 1.5) ? 3.3 : 4.5}vh;
    width: 20vw;
    background-color: #48802A;
    border-radius: 4vw;
  `;

  return (
    <Container>
      <TopContainer>
        {!rrGameOnly && <CloseButton role="button" tabIndex={0} src={images.close} alt="Close" />}
        <CountDownRectangle />
        <CountDownContainer>
          <SecondsCounter seconds={zeroPad('08')} isBeforeGame={false} />
          <TimerImage
            src={clockIcon}
            alt="Timer"
          />
        </CountDownContainer>
      </TopContainer>
      <Levels
        levels={recycleRightData}
        currentLevelKey={`level_${currentLevel + 1}_materials`}
        modalVisible={modalVisible}
      />
      <>
        <CardContainer>
          <Feedback>
            {feedbackState[feedbackStatus]}
          </Feedback>
        </CardContainer>
        <GameStatusIndicator
          totalMaterials={recycleRightData[`level_${currentLevel + 1}_materials`]}
          doneMaterials={doneMaterials}
          prevTotalMaterials={passedMaterialsCount}
        />
      </>
    </Container>
  );
};

export default connect(
  (store) => ({
    recycleRightData: store.recycleRight.allRrData,
    rrGameOnly: store.app.rrGameOnly
  })
)(Feedbacks);
